import { defineMessages } from 'react-intl';

export const systemsMessages = defineMessages({
    systemSettings: {
        id: 'system-settings',
        defaultMessage: 'System settings',
    },
    systems: {
        id: 'systems',
        defaultMessage: 'Systems',
    },
    enabledIdentifierTypes: {
        id: 'enabled-identifier-types',
        defaultMessage: 'Enabled identifier types',
    },
    mainIdentifierType: {
        id: 'main-identifier-type',
        defaultMessage: 'Main identifier type',
    },
    enabledMembershipCategories: {
        id: 'enabled-membership-categories',
        defaultMessage: 'Enabled membership categories',
    },
    enabledEventTypes: {
        id: 'enabled-event-types',
        defaultMessage: 'Enabled event types',
    },
    systemSettingsCreated: {
        id: 'system-settings-created',
        defaultMessage: 'System settings created',
    },
    systemSettingsCreatedSuccess: {
        id: 'system-settings-created-success',
        defaultMessage: 'System settings created successfully',
    },
    systemSettingsUpdated: {
        id: 'system-settings-updated',
        defaultMessage: 'System settings updated',
    },
    systemSettingsUpdatedSuccess: {
        id: 'system-settings-updated-success',
        defaultMessage: 'System settings updated successfully',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    component: {
        id: 'component',
        defaultMessage: 'Component',
    },
    components: {
        id: 'components',
        defaultMessage: 'Components',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    zone: {
        id: 'zone',
        defaultMessage: 'Zone',
    },
    gateway: {
        id: 'gateway',
        defaultMessage: 'Gateway',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    createComponentSuccess: {
        id: 'create-component-success',
        defaultMessage: 'Component created',
    },
    createComponentSuccessDescription: {
        id: 'create-component-success-description',
        defaultMessage: 'Component {entry} has been successfully created.',
    },
    addComponentSubtitle: {
        id: 'add-component-subtitle',
        defaultMessage: 'Add new component',
    },
    hardware: {
        id: 'hardware',
        defaultMessage: 'Hardware',
    },
    software: {
        id: 'software',
        defaultMessage: 'Software',
    },
    LPRCamera: {
        id: 'lpr-camera',
        defaultMessage: 'LPR camera',
    },
    keyReaderCommunicator: {
        id: 'key-reader-communicator',
        defaultMessage: 'Access key reader communicator',
    },
    gatewayCommunicator: {
        id: 'gateway-communicator',
        defaultMessage: 'Gateway communicator',
    },
    tbc: {
        id: 'tbc',
        defaultMessage: 'TBC',
    },
    sensorReaderCommunicator: {
        id: 'sensor-reader-communicator',
        defaultMessage: 'Sensor reader communicator',
    },
    paystationCoreBackend: {
        id: 'paystation-core-backend',
        defaultMessage: 'Paystation core backend',
    },
    paystationCashDevice: {
        id: 'paystation-cash-device',
        defaultMessage: 'Paystation cash device',
    },
    paystationCardService: {
        id: 'paystation-card-service',
        defaultMessage: 'Paystation card service',
    },
    paystationFiscalService: {
        id: 'paystation-fiscal-service',
        defaultMessage: 'Paystation fiscal service',
    },
    spLPR: {
        id: 'sp-lpr',
        defaultMessage: 'SP_LPR',
    },
    spMQTT: {
        id: 'sp-mqtt',
        defaultMessage: 'SP_MQTT',
    },
    make: {
        id: 'make',
        defaultMessage: 'Make',
    },
    model: {
        id: 'model',
        defaultMessage: 'Model',
    },
    serialNumber: {
        id: 'serial-number',
        defaultMessage: 'Serial number',
    },
    RTSPStreamUrl: {
        id: 'rtsp-stream-url',
        defaultMessage: 'RTSP stream url',
    },
    error: {
        id: 'error',
        defaultMessage: 'Error',
    },
    warning: {
        id: 'warning',
        defaultMessage: 'Warning',
    },
    operational: {
        id: 'operational',
        defaultMessage: 'Operational',
    },
    noConnection: {
        id: 'no-connection',
        defaultMessage: 'No connection',
    },
    updateComponentSuccess: {
        id: 'update-component-success',
        defaultMessage: 'Component updated',
    },
    updateComponentSuccessDescription: {
        id: 'update-component-success-description',
        defaultMessage: 'Component {entry} has been successfully updated.',
    },
    editComponentSubtitle: {
        id: 'edit-component-subtitle',
        defaultMessage: 'Edit component {entry}',
    },
    confirmDeleteComponent: {
        id: 'confirm-delete-component',
        defaultMessage: 'Are you sure you want to delete component {entry}? This action cannot be undone.',
    },
    deleteComponentSuccess: {
        id: 'delete-component-success',
        defaultMessage: 'Component deleted',
    },
    deleteComponentSuccessDescription: {
        id: 'delete-component-success-description',
        defaultMessage: 'Component {entry} has been successfully deleted.',
    },
    deleteComponentSubtitle: {
        id: 'delete-component-subtitle',
        defaultMessage: 'Permanently delete component {entry}',
    },
    channel: {
        id: 'channel',
        defaultMessage: 'Channel',
    },
    componentType: {
        id: 'component-type',
        defaultMessage: 'Component type',
    },
    topicCode: {
        id: 'topic-code',
        defaultMessage: 'Topic code',
    },
    persistentChannel: {
        id: 'persistent-channel',
        defaultMessage: 'Persistent channel',
    },
    pulseDuration: {
        id: 'pulse-duration',
        defaultMessage: 'Pulse duration',
    },
    banknoteValidator: {
        id: 'banknote-validator',
        defaultMessage: 'Banknote validator',
    },
    coinHopper: {
        id: 'coin-hopper',
        defaultMessage: 'Coin hopper',
    },
    coinMechanism: {
        id: 'coin-mechanism',
        defaultMessage: 'Coin mechanism',
    },
    coinAcceptor: {
        id: 'coin-acceptor',
        defaultMessage: 'Coin acceptor',
    },
    cctalkInterface: {
        id: 'cctalk-interface',
        defaultMessage: 'ccTalk interface',
    },
    firmwareVersion: {
        id: 'firmware-version',
        defaultMessage: 'Firmware version',
    },
    manufacturer: {
        id: 'manufacturer',
        defaultMessage: 'Manufacturer',
    },
    jcm: {
        id: 'jcm',
        defaultMessage: 'JCM',
    },
    innovativeTechnology: {
        id: 'innovative-technology',
        defaultMessage: 'Innovative Technology',
    },
    whMunzprufer: {
        id: 'wh-munzprufer',
        defaultMessage: 'wh Münzprüfer',
    },
    cct900: {
        id: 'cct-900',
        defaultMessage: 'CCT 900',
    },
    cct910: {
        id: 'cct-910',
        defaultMessage: 'CCT 910',
    },
    currencyDataset: {
        id: 'currency-dataset',
        defaultMessage: 'Currency dataset',
    },
    gatewayDisplay: {
        id: 'gateway-display',
        defaultMessage: 'Gateway display',
    },
    displayServerIP: {
        id: 'display-server-ip',
        defaultMessage: 'Server URL',
    },
    displayServerApiKey: {
        id: 'display-server-api-key',
        defaultMessage: 'Server API key',
    },
    spDisplayModal: {
        id: 'sp-display-modal',
        defaultMessage: 'SP',
    },
    huiduDisplayModal: {
        id: 'huidu-display-modal',
        defaultMessage: 'HUIDU',
    },
    ned200DisplayModal: {
        id: 'ned200-display-modal',
        defaultMessage: 'NED200',
    },
    open: {
        id: 'open',
        defaultMessage: 'Open',
    },
    closed: {
        id: 'closed',
        defaultMessage: 'Closed',
    },
    listenState: {
        id: 'listen-state',
        defaultMessage: 'Listen state',
    },
    statusListenState: {
        id: 'status-listen-state',
        defaultMessage: 'Status listen state',
    },
    statusChannel: {
        id: 'status-channel',
        defaultMessage: 'Status channel',
    },
    idleStateDate: {
        id: 'idle-state-date',
        defaultMessage: 'Date',
    },
    idleStateSpaces: {
        id: 'idle-state-spaces',
        defaultMessage: 'Spaces',
    },
    idleStateLprDetection: {
        id: 'idle-state-lpr-detection',
        defaultMessage: 'LPR',
    },
    idleStateTicketDetection: {
        id: 'idle-state-ticket-detection',
        defaultMessage: 'Ticket',
    },
    idleStateCardDetection: {
        id: 'idle-state-card-detection',
        defaultMessage: 'Card',
    },
    idleState: {
        id: 'idle-state',
        defaultMessage: 'Idle state',
    },
    orientation: {
        id: 'orientation',
        defaultMessage: 'Orientation',
    },
    portrait: {
        id: 'portrait',
        defaultMessage: 'Portrait',
    },
    landscape: {
        id: 'landscape',
        defaultMessage: 'Landscape',
    },
    sdkKey: {
        id: 'sdk-key',
        defaultMessage: 'SDK key',
    },
    sdkSecret: {
        id: 'sdk-secret',
        defaultMessage: 'SDK secret',
    },
    deviceId: {
        id: 'device-id',
        defaultMessage: 'Device ID',
    },
    screenWidth: {
        id: 'screen-width',
        defaultMessage: 'Screen width',
    },
    screenHeight: {
        id: 'screen-height',
        defaultMessage: 'Screen height',
    },
    displayModel: {
        id: 'display-model',
        defaultMessage: 'Display model',
    },
});
